import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const EventSurveyApi = createApi({
  reducerPath: "eventSurveyApi",
  baseQuery: customBaseQuery,
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 60,
  tagTypes: ["eventSurvey"],
  endpoints: (builder) => ({
    getEventSurveys: builder.query({
      query: (eventId) => ({
        url: `/event/survey/fetchSurvey/${eventId}`,
        method: "GET"
      }),
      extraOptions: { service: "TMS" }
    })
  })
});

export const { useGetEventSurveysQuery } = EventSurveyApi;
